import {MeterIcon} from '@primer/octicons-react'
import {AnchoredOverlay, IconButton} from '@primer/react'
import {useState} from 'react'

import {TokenUsageInfo} from './TokenUsageInfo'

export function MeterButton() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <AnchoredOverlay
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      renderAnchor={props => (
        <IconButton icon={MeterIcon} aria-label="View token usage" variant="invisible" size="medium" {...props} />
      )}
      side="outside-top"
      align="center"
      anchorOffset={22}
      alignmentOffset={4}
      width="medium"
    >
      <TokenUsageInfo />
    </AnchoredOverlay>
  )
}
